module.exports = __webpack_public_path__ + "static/img/settingsucesse1.22fbfdab.jpg";